import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { EvaluationStatus } from '@/types/evaluation.types';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: EvaluationStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function StatusBadge({ status, size = 'md', className }: StatusBadgeProps) {
  const { t } = useTranslation('common');

  // Color mapping for each status
  const statusStyles = {
    [EvaluationStatus.Organizing]: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200 border-blue-200 dark:border-blue-900',
    [EvaluationStatus.Active]: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200 border-green-200 dark:border-green-900',
    [EvaluationStatus.Concluded]: 'bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200 border-purple-200 dark:border-purple-900',
    [EvaluationStatus.Closed]: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700',
  };

  // Size mapping
  const sizeStyles = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-0.5',
    lg: 'text-base px-3 py-1',
  };

  return (
    <Badge
      variant="outline"
      className={cn(
        statusStyles[status],
        sizeStyles[size],
        'font-medium',
        className
      )}
    >
      {t(`status.${status.toLowerCase()}`)}
    </Badge>
  );
}
